<footer class="footer">
    <div class="d-sm-flex justify-content-center justify-content-sm-between">
        <span class="text-muted d-block text-center text-sm-left d-sm-inline-block" *ngIf="Role != 'Printer'">Copyright © {{CurrentYear}} Jai Baba Balak Nath</span>
    </div>
</footer>